import React, { useEffect, useState } from 'react';
import './style.scss';
import Heading from 'app/helpers/Heading';
import { Grid } from '@material-ui/core';
import ReuseableSelect from 'app/components/Select/Select';
import Input from 'app/components/Input/Input';
import ButtonGroup from 'app/components/ButtonGroup/ButtonGroup';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { axiosInstance, errorHandler } from 'app/helpers';
import { setAlert } from 'app/redux/actions/alertAction';
import { useDispatch } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import LandModal from 'app/components/LandModal/LandModal';
import { MultiLandComponent } from 'app/components';

const validationSchema = Yup.object().shape({
    name: Yup.string().required('required'),
    NicNo: Yup.string().required('required'),
    contactNo: Yup.string().required('required'),
});

const LandBooker = () => {
    const [isLoad, setIsLoad] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [show, setShow] = useState(false);
    const [getAllStatesAndLands, setGetAllStatesAndLands] = useState([]);
    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: {
            name: '',
            NicNo: '',
            contactNo: '',
            state_id: '',
            lands: [],
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setIsLoad(true);
            const Lands = values.lands?.map((Ele) => {
                return {
                    land_id: Ele?.id,
                };
            });
            try {
                const data = await axiosInstance.post('/cattleMandi/add-land-booker', {
                    name: values.name,
                    cnic: values.NicNo,
                    contact_number: values.contactNo,
                    lands: Lands,
                });
                setIsLoad(false);
                dispatch(
                    setAlert({
                        isOpen: true,
                        type: 'success',
                        message: 'Land record created',
                    })
                );
                setTimeout(() => {
                    dispatch(setAlert({}));
                }, 5000);
                window.location.href = `view-land-receipt/${data?.data?.data?.data?.id}`;
                formik.resetForm();
            } catch (error) {
                console.log({ error });
                dispatch(
                    setAlert({
                        isOpen: true,
                        type: 'error',
                        message: errorHandler(error),
                    })
                );
                setTimeout(() => {
                    dispatch(setAlert({}));
                }, 5000);
                setIsLoad(false);
                // API error
            } finally {
                setIsLoad(false);
            }
        },
    });

    const handleNumberKeyDown = (e) => {
        if (e.key === 'e' || e.key === '-') {
            e.preventDefault();
        }
    };

    const handleClose = (land) => {
        const landsSelected = formik.values.lands;
        const filteredLands = landsSelected.filter((item) => {
            return item?.id !== land?.id;
        });
        formik.setFieldValue('lands', filteredLands);
    };

    // func
    const formatNIC = (value) => {
        if (value && value.length === 13) {
            return `${value.substring(0, 5)}-${value.substring(5, 12)}-${value.charAt(12)}`;
        }
        return value;
    };

    const getStatesLands = async () => {
        try {
            const { data } = await axiosInstance.get('/cattleMandi/get-state-lands');
            setGetAllStatesAndLands(data?.data?.filter((Ele) => Ele.price !== 0));
        } catch (error) {
            dispatch(
                setAlert({
                    isOpen: true,
                    type: 'error',
                    message: errorHandler(error),
                })
            );
            setTimeout(() => {
                dispatch(setAlert({}));
            }, 5000);
        }
    };

    useEffect(() => {
        getStatesLands();
    }, []);

    useEffect(() => {
        if (!!formik.values.state_id && formik.values.state_id !== 'Select lands') {
            setIsOpen(true);
        }
    }, [formik.values.state_id]);

    return (
        <div className="LandBooker_Container">
            <Heading heading="Land Booker" />
            <div className="LandBooker_Content">
                <div className="LandBooker_Card">
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            formik.submitForm();
                        }}
                    >
                        <div>
                            <Grid container spacing={3}>
                                <Grid item md={6} xs={12} sm={12} className="TextInput_Main">
                                    <label>Name</label>
                                    <Input
                                        type="text"
                                        name="name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        className="TextInput"
                                        error={formik.touched.name && formik.errors.name}
                                        // onKeyDown={handleNumberKeyDown}
                                        placeholder="Type Here"
                                    />
                                    {formik.touched.name && formik.errors.name && (
                                        <div className="error">{formik.errors.name}</div>
                                    )}
                                </Grid>

                                <Grid item md={6} xs={12} sm={12} className="TextInput_Main">
                                    <label>Contact No</label>
                                    <Input
                                        type="text"
                                        name="contactNo"
                                        onKeyDown={handleNumberKeyDown}
                                        value={formik.values.contactNo}
                                        onChange={formik.handleChange}
                                        className="TextInput"
                                        error={formik.touched.contactNo && formik.errors.contactNo}
                                        placeholder="Type Here"
                                    />
                                    {formik.touched.contactNo && formik.errors.contactNo && (
                                        <div className="error">{formik.errors.contactNo}</div>
                                    )}
                                </Grid>

                                <Grid item md={6} xs={12} sm={12} className="TextInput_Main">
                                    <label>N.I.C No</label>
                                    <Input
                                        type="text"
                                        name="NicNo"
                                        value={formik.values.NicNo}
                                        onChange={formik.handleChange}
                                        className="TextInput"
                                        onKeyDown={handleNumberKeyDown}
                                        error={formik.touched.NicNo && formik.errors.NicNo}
                                        placeholder="Type Here"
                                    />
                                    {formik.touched.NicNo && formik.errors.NicNo && (
                                        <div className="error">{formik.errors.NicNo}</div>
                                    )}
                                </Grid>

                                <Grid item md={6} xs={12} sm={12} className="TextInput_Main">
                                    <div className="TextInput_Main">
                                        <label htmlFor="name">Select Lands</label>

                                        <>
                                            <ReuseableSelect
                                                style={{ width: '100%' }}
                                                name="state_id"
                                                formControlClassName="demo-customized-select"
                                                className={`TextInput select_error`}
                                                formik={formik}
                                                value={formik.values.state_id}
                                                onChange={formik.handleChange}
                                                error={formik.touched.state_id && formik.errors.state_id}
                                                optionList={getAllStatesAndLands}
                                                showOption={'Select lands'}
                                            />
                                            {formik.touched.state_id && formik.errors.state_id && (
                                                <div className="error">{formik.errors.state_id}</div>
                                            )}
                                        </>
                                        {Boolean(formik?.values?.lands.length) && (
                                            <MultiLandComponent
                                                lands={formik.values.lands}
                                                // isLandBooker={isLandBooker}
                                                showCloseButton={true}
                                                onClose={handleClose}
                                            />
                                        )}
                                    </div>
                                </Grid>

                                <Grid item md={12} xs={12} sm={12} className="TextInput_Main">
                                    <div className="Btn_Container_Two">
                                        <ButtonGroup
                                            value="submit"
                                            type="submit"
                                            variant="contained"
                                            customBtnBGColor="#7904d7"
                                            textColor="#fff"
                                            disabled={isLoad}
                                            isLoad={isLoad}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </form>
                </div>
            </div>
            <LandModal
                open={isOpen}
                setIsOpen={setIsOpen}
                stateLandData={[]}
                id={formik.values.state_id || ''}
                data={getAllStatesAndLands}
                formik={formik}
                // getLand={getLand}
            />
        </div>
    );
};

export default LandBooker;
